import Vue from "vue";
import {
  cloudinaryDelivery,
  cloudinaryTransform,
} from "@/utils/cloudinary-delivery";
export default Vue.extend({
  methods: {
    image(value: string): string {
      return require(`@/assets/images/${value}`);
    },
    resize(img, size = 600) {
      return cloudinaryTransform(img, `f_auto,q_auto,c_fit,h_${size}`);
    },
    cloudinaryDelivery,
    cloudinaryTransform,
  },
});
